import classnames from 'classnames';
import * as React from 'react';
// @ts-expect-error
import {components, OptionProps} from 'react-select';

import {Avatar} from 'shells/avatar/avatar';

import {getApiTypeFromGraphQLTypename, getSingularEntityType} from 'nutshell-core/utils';

// @ts-expect-error
import {GraphQLSelectInline, Option} from './graphql-select-inline';
import {useGetRelatedEntities} from './hooks/use-get-related-entities';

import styles from './graphql-select-options.module.css';

type Props = {
    selectedValues: Option[];
    onChange: (values: Option | Option[]) => any;
    onClearValue?: () => void;
    isMulti: boolean;
    clearable?: boolean;
    disabled?: boolean;
    hasDropdownIndicator?: boolean;
    searchable?: boolean;
    openMenuOnClick?: boolean;
    defaultOptions?: true | any[];
};

export function GraphQLSelectEntities(props: Props) {
    const {fetchMore, isLoading} = useGetRelatedEntities();

    const handleLoadOptions = (search?: string | null) => {
        return fetchMore(search).then(({data}) => {
            const quickResults = data.search ? data.search.quickResults : null;

            let topResults = quickResults ? quickResults.topResults : [];

            if (topResults.length === 0) {
                const recentResults =
                    quickResults && quickResults.recentResults ? quickResults.recentResults : [];
                if (recentResults && recentResults.length > 0) {
                    // only first 5
                    topResults = recentResults.slice(0, 5);
                }
            }

            return Promise.resolve(topResults);
        });
    };

    return (
        <GraphQLSelectInline
            placeholder='Type to search…'
            value={props.selectedValues}
            multi={props.isMulti}
            defaultOptions={props.defaultOptions}
            onClearValue={props.onClearValue}
            loadOptions={handleLoadOptions}
            onChange={props.onChange}
            onBlur={() => {
                props.onChange(props.selectedValues);
            }}
            noOptionsMessage={({inputValue}) => {
                if (isLoading) {
                    return 'Getting recent results…';
                }
                if (inputValue.length) {
                    return `Nothing found matching '${inputValue}'`;
                }
                if (inputValue.length === 0) {
                    return 'No recent results. Type to search…';
                }

                return null;
            }}
            components={{Option: OptionComponent}}
            labelKey='name'
            valueKey='id'
            clearable={props.clearable}
            shouldStyleValueByType={true}
            disabled={props.disabled}
            hasDropdownIndicator={props.hasDropdownIndicator}
            searchable={props.searchable}
            openMenuOnClick={props.openMenuOnClick}
        />
    );
}

const OptionComponent = (props: OptionProps) => {
    // This is a hack to get around limitations in our old version of flow
    const spreadableProps: OptionProps = props as any;
    const entityType = getApiTypeFromGraphQLTypename(props.data.__typename);

    const name = props.data.name ? (
        <div className={styles['option-label']}>{props.data.name}</div>
    ) : (
        <div className={classnames('italic', styles['option-label'])}>
            Unnamed {getSingularEntityType(entityType)}
        </div>
    );

    return (
        <components.Option {...spreadableProps}>
            <div className={styles['option-wrapper']}>
                <Avatar
                    avatarUrl={props.data.avatarUrl}
                    initials={props.data.initials}
                    type={entityType}
                />
                {name}
            </div>
        </components.Option>
    );
};
